import { Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { USER_FORM_NAME } from 'src/app/services/form/form.factory';
import { UserEmailForm } from 'src/app/services/form/form.controls';
import { FormService } from 'src/app/services/form/form.service';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatError } from '@angular/material/input';
import { PayeeInfoComponent } from '../../../../shared/payee-info/payee-info.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-email-form',
  templateUrl: './user-email-form.component.html',
  styleUrls: ['./user-email-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    MatCheckbox,
    MatError,
    PayeeInfoComponent,
    TranslateModule,
  ],
})
export class UserEmailFormComponent {
  private formService = inject(FormService);

  get form(): UserEmailForm {
    return this.formService.form.controls[USER_FORM_NAME]!;
  }

  get userEmail() {
    return this.form.controls.email;
  }
  get terms_of_service() {
    return this.form.controls.terms_of_service;
  }
  get password() {
    return this.form.controls.password;
  }

  showLoginForm = false;
  loginLoading = false;

  onShowLoginForm() {
    this.showLoginForm = true;

    this.updateWholeForm();
    this.password.enable();
    this.terms_of_service.disable();
  }

  onShowRegisterForm() {
    this.showLoginForm = false;

    this.updateWholeForm();
    this.password.disable();
    this.terms_of_service.enable();
  }

  private updateWholeForm(
    form: AbstractControl = this.formService.form,
    maxDepth = 32,
  ): void {
    if (maxDepth <= 0) {
      return;
    }

    if (form instanceof FormControl) {
      form.updateValueAndValidity();
    } else if (form instanceof FormGroup) {
      form.updateValueAndValidity();
      for (const control of Object.values(form.controls)) {
        this.updateWholeForm(control, maxDepth - 1);
      }
    } else if (form instanceof FormArray) {
      form.updateValueAndValidity();
      for (const control of form.controls) {
        this.updateWholeForm(control, maxDepth - 1);
      }
    }
  }
}
